import * as React from 'react';
import * as Tgcc from '../../tgccGlobal';
import * as Request from '../../tgccRequest';
import { CSSProperties } from 'react';

declare var paymentTokenizationKey: string;
declare var braintree: any;
declare var ServerUrlRoot: string;

const paymentButtonId: string = 'payment-button';

const rowStyle: React.CSSProperties = {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'nowrap',
    height: '35px'
}
const btppStyle = Object.assign({}, rowStyle, { margin: "15px 30px" });
const paymentDisabledStyle: React.CSSProperties = {
    content: 'url(' + Tgcc.ResolveUrl('~/images/paymentbraintree.png') + ')',
    height: '25px',
    opacity: 0.7
}
const wrapperStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '15px'
}
const titleStyle: CSSProperties = {
    fontWeight: 'bold'
}
const summaryBoxStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    border: '1px solid black',
    margin: '3px 0'
}
const summaryRowStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
}
const summaryLabelStyle: CSSProperties = {
    display: 'flex',
    flexBasis: '100%',
    flex: 2
}
const summaryValueStyle: CSSProperties = {
    display: 'flex',
}
const checkoutBoxStyle: CSSProperties = {
    border: '1px black solid',
    padding: '4px'
}
let checkoutBtnStyle: React.CSSProperties = {
    display: 'none', // starts hidden
    alignSelf: 'stretch',
    border: '1px solid black',
    justifyContent: 'center',
    lineHeight: '25px',
    marginTop: '5px',
}
const checkoutRowStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row'
}
const checkoutLabelStyle: CSSProperties = {
    display: 'flex',
    flex: 1,
    margin: '0 3px'
}
const checkoutInputStyle: CSSProperties = {
    display: 'flex',
    flex: 1,
    border: Tgcc.Styles.singleBorder,
    margin: '3px'
}
const checkoutSectionStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    lineHeight: '30px',
    fontSize: '17px',
    marginLeft: '3px',
    justifyContent: 'center'
}
const errorStyle: CSSProperties = {
    display: 'flex',
    color: 'darkred',
    fontSize: '16px',
    lineHeight: '28px',
    marginLeft: '5px',
    fontStyle: 'italic'
}
const isBlankOrEmpty = (str: string) => {
    if (!str)
        return true;
    if (!str.trim())
        return true;
    return false;
}
class StateType {
    addressVerifyModel: Tgcc.AddressVerifyModel;
    isWaiting: boolean;
    error: string;
    email: string;
    address1: string;
    address2: string;
    addrState: string;
    addrCity: string;
    addrZip: string;
    firstName: string;
    lastName: string;
    disableEdits: boolean;
    purchaseComplete: boolean;
}
type Props = {
    cart: Tgcc.WebStoreCart;
    webStore: Tgcc.WebStore;
    completeCheckout: (email: string) => void;
}

export class ShopCheckout extends React.Component<Props, any>{
    state: StateType = {
        addressVerifyModel: new Tgcc.AddressVerifyModel,
        isWaiting: false,
        error: null,
        firstName: '',
        lastName: '',
        email: '',
        address1: '',
        address2: '',
        addrCity: '',
        addrState: '',
        addrZip: '',
        disableEdits: false,
        purchaseComplete: false
    }

    componentDidMount = () => {
        this.handleDynamicEdits();
    }
    componentDidUpdate = () => {
        this.handleDynamicEdits();
    }

    getSubtotal = (): number => {
        var subtotal: number = 0;
        this.props.cart.items.forEach((item) => {
            subtotal += item.quantity * item.tBanker.price;
        });
        return subtotal;
    }
    getItemCount = (): number => {
        var count: number = 0;
        this.props.cart.items.forEach((item) => {
            count += (1 * item.quantity); // multiply by 1 to avoid string concat
        });
        return count;
    }
    getShipping = (): number => {
        if (!this.isIndividualShip())
            return 0;

        var totalCt = this.getItemCount();
        var shipping: number = 0;

        if (this.props.webStore.shipCostFirst > 0)
            shipping += (1 * this.props.webStore.shipCostFirst);

        if (this.props.webStore.shipCostAdditional > 0)
            shipping += (totalCt - 1) * this.props.webStore.shipCostAdditional;

        return shipping;
    }
    getError = () => {
        if (this.state.error)
            return <div style={errorStyle}>{this.state.error}</div>
        return <div></div>
    }
    isEmpty = (val: string) => {
        return val == null || val.length == 0;
    }

    getValidationError = () => {
        if (this.isEmpty(this.state.firstName)) return 'Please enter First Name';
        if (this.isEmpty(this.state.lastName)) return 'Please enter Last Name';

        if (!Tgcc.IsValidEmail(this.state.email)) return 'Please enter valid email';

        if (this.isEmpty(this.state.address1)) return 'Please enter valid street address';
        if (this.isEmpty(this.state.addrCity)) return 'Please enter City';
        if (this.isEmpty(this.state.addrState)) return 'Please enter State';
        if (this.isEmpty(this.state.addrZip)) return 'Please enter Zip';
        return null;
    }

    streetAddressNotEmpty = () => {
        return this.state.address1 && this.state.address1.length > 5;
    }

    cityIsValid = () => {
        return this.state.addrCity && this.state.addrCity.length > 1;
    }

    stateIsValid = () => {
        var states: Array<string> = ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'];
        return this.state.addrState && (states.indexOf(this.state.addrState.toString().toUpperCase()) >= 0);
    }

    zipIsValid = () => {
        var zipCodePattern = /^\d{5}$|^\d{5}-\d{4}$/;
        return zipCodePattern.test(this.state.addrZip);
    }

    isIndividualShip = () => this.props.webStore.shipType == Tgcc.ShipmentTypes.Individual;

    allFieldsAreValid = () => {
        var individualShip = this.isIndividualShip();

        if (individualShip && !this.streetAddressNotEmpty())
            this.setState({ error: 'Address is not valid.', isWaiting: false });

        else if (individualShip && !this.cityIsValid())
            this.setState({ error: 'City  is not valid.', isWaiting: false });

        else if (individualShip && !this.stateIsValid())
            this.setState({ error: 'State is not valid.', isWaiting: false });

        else if (individualShip && !this.zipIsValid())
            this.setState({ error: 'Zip Code is not valid.', isWaiting: false });

        else if (!this.state.firstName || !this.state.firstName.trim())
            this.setState({ error: 'First name cannot be blank.', isWaiting: false });

        else if (!this.state.lastName || !this.state.lastName.trim())
            this.setState({ error: 'Last name cannot be blank.', isWaiting: false });

        else if (!Tgcc.IsValidEmail(this.state.email))
            this.setState({ error: 'Email is not valid.', isWaiting: false });

        else if (individualShip && !this.addressIsVerified())
            this.setState({ error: 'Shipping address is incorrect' });

        else
            this.setState({ error: null })

        return true;
    }

    addressIsVerified = () => {

        return this.state.addressVerifyModel
            && (this.state.addressVerifyModel.addr1 || this.state.addressVerifyModel.addr2)
            && this.state.addressVerifyModel.city
            && this.state.addressVerifyModel.state
            && this.state.addressVerifyModel.zip
            && !this.state.addressVerifyModel.error
    }

    getRecommendedAddressChange = (avm: Tgcc.AddressVerifyModel) => {
        var newState: any = {
            addressVerifyModel: avm
        };

        // swap addr1/addr2 comes in opposite of what we expect
        if (!this.state.addressVerifyModel
            || this.state.addressVerifyModel.addr2 != avm.addr2
            || isBlankOrEmpty(this.state.address1))
            newState.address1 = avm.addr2;
        if (!this.state.addressVerifyModel
            || this.state.addressVerifyModel.addr1 != avm.addr1
            || isBlankOrEmpty(this.state.address2))
            newState.address2 = avm.addr1;
        if (!this.state.addressVerifyModel
            || this.state.addressVerifyModel.city != avm.city
            || isBlankOrEmpty(this.state.addrCity))
            newState.addrCity = avm.city;
        if (!this.state.addressVerifyModel
            || this.state.addressVerifyModel.zip != avm.zip
            || isBlankOrEmpty(this.state.addrZip))
            newState.addrZip = avm.zip;
        if (!this.state.addressVerifyModel
            || this.state.addressVerifyModel.state != avm.state
            || isBlankOrEmpty(this.state.addrState))
            newState.addrState = avm.state;

        return newState.address1
            || newState.address2
            || newState.addrCity
            || newState.addrState
            || newState.addrZip
            || newState.addrState
            ? newState : null
    }

    verifyAddress = () => {
        // trigger validation if we have all the fields entered
        if (this.state.address1 && ((this.state.addrCity && this.state.addrState) || this.state.addrZip)) {
            Request.verifyAddress(this.state.address2, this.state.address1, this.state.addrCity, this.state.addrState, this.state.addrZip,
                // success
                (avm: Tgcc.AddressVerifyModel) => {
                    if (avm.error)
                        this.setState({ error: avm.error });
                    else {
                        var stateChange = this.getRecommendedAddressChange(avm);
                        if (stateChange)
                            this.setState(stateChange, this.allFieldsAreValid);
                    }
                },
                // error
                (err: any) => {
                    console.log("validate address request failed: ", err);
                }
            );
        }
    }

    doCheckout = (evt: any) => {
        var err = this.getValidationError();
        if (err)
            this.setState({ error: err });
        else
            this.props.completeCheckout(this.state.email);
    }

    makePayment = (instance: any, oncomplete: any, showButton: any) => {
        instance.requestPaymentMethod(function (requestPaymentMethodErr, payload) {
            if (showButton)
                showButton(false);

            if (requestPaymentMethodErr) {
                document.getElementsByClassName("braintree-toggle")[0]['style']["display"] = "inherit"; // show payment change
                console.log("paymentErr: ", requestPaymentMethodErr);
                showButton(true);
                return;
            }
            console.log("Complete payment: ", payload);
            oncomplete(payload);
        });
    }

    checkoutInputChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        var fldChange = {};
        if (evt.currentTarget.type == 'number')
            fldChange[evt.currentTarget.name] = parseInt(evt.currentTarget.value);
        else
            fldChange[evt.currentTarget.name] = evt.currentTarget.value;

        var targetName = evt.currentTarget.name;
        this.setState(fldChange, () => {
            //initiate address validation if needed
            if (this.isIndividualShip() &&
                (targetName === 'address1'
                    || targetName === 'address2'
                    || targetName === 'addrCity'
                    || targetName === 'addrState'
                    || targetName === 'addrZip')) {
                this.verifyAddress();
            }
            this.allFieldsAreValid()
        });
    }

    disableFields = () => { this.setState({ disableEdits: true }); }
    isHidden = (el) => { if (el == null) return true; return (el.offsetParent === null); }
    showButton = (show) => {
        var button = document.getElementById(paymentButtonId);
        if (button)
            button.style["display"] = show ? "inherit" : "none";
    }

    handleDynamicEdits = () => {
        var btreeButton = document.getElementById(paymentButtonId);
        if (btreeButton) {
            if (!this.braintreeInitialized) {
                this.braintreeInitialized = true;
                this.setupBrainTreeButton();
            }
        }
    }

    setupBrainTreeButton = () => {
        var subtotal = this.getSubtotal();
        var shipping = this.getShipping();
        var price = subtotal + shipping;
        var button = document.getElementById(paymentButtonId);
        var makePayment = this.makePayment;
        var oncomplete = this.completePayment;
        var fieldsValid = this.allFieldsAreValid;
        var disableFields = this.disableFields;
        var showButton = this.showButton;

        var btDropin = braintree.dropin.create({
            authorization: paymentTokenizationKey,
            container: '#braintree-container',
            dataCollector: { kount: true, paypal: true}
        }, function (createErr, instance) {
            if (instance) {
                var chkInterval = setInterval(function () {
                    if (instance.isPaymentMethodRequestable() && fieldsValid()) {
                        showButton(true);
                        clearInterval(chkInterval);
                    } else {
                        showButton(false);
                    }
                }, 400);

                button.addEventListener('click', function () {
                    if (fieldsValid()) {
                        disableFields();
                        clearInterval(chkInterval);
                        console.log("Request payment setup: ", instance, createErr);
                        makePayment(instance, oncomplete, showButton);
                    }
                });
            }
        }
        );
    }

    getCheckout = (): Tgcc.Checkout => {
        var checkoutData: Tgcc.Checkout = {
            Organization: null,
            IndividualShip: this.props.webStore.shipType == 1,
            FirstName: this.state.firstName,
            LastName: this.state.lastName,
            Email: this.state.email,
            AddrLine1: this.state.address1,
            AddrLine2: this.state.address2,
            AddrCity: this.state.addrCity,
            AddrState: this.state.addrState,
            AddrZip: this.state.addrZip
        };
        return checkoutData;
    }

    getCartItems = (): Tgcc.WebStoreCartItemModel[] => {
        var itemModels: Tgcc.WebStoreCartItemModel[] = [];
        this.props.cart.items.forEach((item) => {
            var model: Tgcc.WebStoreCartItemModel = {
                ItemId: item.id,
                TbCode: item.tBanker.code,
                Price: item.tBanker.price,
                Quantity: item.quantity,
                Size: item.size
            };
            itemModels.push(model);
        });
        return itemModels;
    }

    completePayment = (data: any) => {
        this.setState({ error: null, isWaiting: true });
        var checkout: Tgcc.Checkout = this.getCheckout();
        var cartItems: Tgcc.WebStoreCartItemModel[] = this.getCartItems()
        Request.processWebshopBraintreePayment(
            data.nonce,
            data.deviceData,
            cartItems,
            checkout,
            this.paymentComplete,
            this.paymentFailed);
    }

    paymentComplete = (data: any) => {
        this.setState({ error: "Order Received", isWaiting: false, venmoUser: data.venmoUser, cardNumber: data.cardNumber, purchaseComplete: true, disableEdits: true });
        this.props.completeCheckout(this.state.email);
    }

    paymentFailed = (err: string) => {
        this.braintreeInitialized = false;
        document.getElementsByClassName("braintree-toggle")[0]['style']["display"] = "inherit"; // show payment change
        console.log("error processing payment: ", err);
        this.setState({ error: err, isWaiting: false, disableEdits: true });
        this.showButton(true);
    }

    braintreeInitialized = false;

    getShippingSection = () => {
        var editDisabled = this.state.disableEdits || this.state.purchaseComplete ? true : false;

        return this.isIndividualShip()
            ? (<div>
                <div style={checkoutSectionStyle}>
                    Shipping
                </div>
                <div style={checkoutRowStyle}>
                    <div style={checkoutLabelStyle}>Street Address*</div>
                </div>
                <div style={checkoutRowStyle}>
                    <input type="text" name="address1" value={this.state.address1} style={checkoutInputStyle} onChange={this.checkoutInputChanged} disabled={editDisabled} />
                </div>
                <div style={checkoutRowStyle}>
                    <div style={checkoutLabelStyle}>Address 2</div>
                </div>
                <div style={checkoutRowStyle}>
                    <input type="text" name="address2" value={this.state.address2} style={checkoutInputStyle} onChange={this.checkoutInputChanged} disabled={editDisabled} />
                </div>
                <div style={checkoutRowStyle}>
                    <div style={checkoutLabelStyle}>City*</div>
                    <div style={checkoutLabelStyle}>State*</div>
                </div>
                <div style={checkoutRowStyle}>
                    <input type="text" name="addrCity" value={this.state.addrCity} style={checkoutInputStyle} onChange={this.checkoutInputChanged} disabled={editDisabled} />
                    <input type="text" name="addrState" value={this.state.addrState} style={checkoutInputStyle} onChange={this.checkoutInputChanged} disabled={editDisabled} />
                </div>
                <div style={checkoutRowStyle}>
                    <div style={checkoutLabelStyle}>Zip*</div>
                    <div style={checkoutLabelStyle}></div>
                </div>
                <div style={checkoutRowStyle}>
                    <input type="text" name="addrZip" value={this.state.addrZip} style={checkoutInputStyle} onChange={this.checkoutInputChanged} disabled={editDisabled} />
                    <div style={checkoutLabelStyle}></div>
                </div>
            </div>)
            : (<div>
                <div style={checkoutSectionStyle}>
                    Shipping
                </div>
                <div style={checkoutRowStyle}>
                    <div style={checkoutLabelStyle}>Organization</div>
                </div>
                <div style={checkoutRowStyle}>
                    <input readOnly type="text" name="shipOrg" value={this.props.webStore.organization} style={checkoutInputStyle} disabled={true} />
                </div>
                <div style={checkoutRowStyle}>
                    <div style={checkoutLabelStyle}>Shipping Contact</div>
                </div>
                <div style={checkoutRowStyle}>
                    <input readOnly type="text" name="shipContact" value={this.props.webStore.contactName} style={checkoutInputStyle} disabled={true} />
                </div>
                <div style={checkoutRowStyle}>
                    <div style={checkoutLabelStyle}>Shipping Email</div>
                </div>
                <div style={checkoutRowStyle}>
                    <input readOnly type="text" name="shipEmail" value={this.props.webStore.contactEmail} style={checkoutInputStyle} disabled={true} />
                </div>
            </div>)
    }

    render() {
        var subtotal = this.getSubtotal();
        var shipping = this.getShipping();
        var total = subtotal + shipping;
        var errorMsg = this.getError();
        var hasBasicInfo = this.state.firstName && this.state.lastName && this.state.email;
        var canPay = this.braintreeInitialized
            || (!this.isIndividualShip() && hasBasicInfo)
            || (this.isIndividualShip() && hasBasicInfo && this.addressIsVerified());
        var paymentBox = canPay ?
            <div id="braintree-container" style={{ display: 'flex', flexDirection: 'row', width: '100%' }}></div>
            : <div id="braintree-container" style={btppStyle}><img src={Tgcc.ResolveUrl('~/images/paymentbraintree.png')} style={paymentDisabledStyle} /></div>;
        var paymentBtn = canPay ? <button id={paymentButtonId} style={checkoutBtnStyle}>Submit order!</button> : <div></div>
        var waiting = this.state.isWaiting ? Tgcc.workingGif : null;
        return (
            <div style={wrapperStyle}>
                <div style={summaryRowStyle}>
                    <div style={titleStyle}>Order Summary:</div>
                </div>
                <div style={summaryBoxStyle}>
                    <div style={summaryRowStyle}>
                        <div style={summaryLabelStyle}>Subtotal</div>
                        <div style={summaryValueStyle}>{subtotal.toFixed(2)}</div>
                    </div>
                    <div style={summaryRowStyle}>
                        <div style={summaryLabelStyle}>Shipping</div>
                        <div style={summaryValueStyle}>{shipping > 0 ? shipping.toFixed(2) : "FREE"}</div>
                    </div>
                    <div style={summaryRowStyle}>
                        <div style={summaryLabelStyle}>TOTAL</div>
                        <div style={summaryValueStyle}>${total.toFixed(2)}</div>
                    </div>
                </div>
                <div style={checkoutBoxStyle}>
                    <div style={checkoutRowStyle}>
                        <div style={checkoutLabelStyle}>First Name*</div>
                        <div style={checkoutLabelStyle}>Last Name*</div>
                    </div>
                    <div style={checkoutRowStyle}>
                        <input type="text" name="firstName" value={this.state.firstName} style={checkoutInputStyle} onChange={this.checkoutInputChanged} />
                        <input type="text" name="lastName" value={this.state.lastName} style={checkoutInputStyle} onChange={this.checkoutInputChanged} />
                    </div>
                    <div style={checkoutRowStyle}>
                        <div style={checkoutLabelStyle}>Email*</div>
                    </div>
                    <div style={checkoutRowStyle}>
                        <input type="text" name="email" value={this.state.email} style={checkoutInputStyle} onChange={this.checkoutInputChanged} />
                    </div>

                    {this.getShippingSection()}

                    <div style={checkoutSectionStyle}>
                        {paymentBox}
                        {paymentBtn}
                    </div>
                    <div style={checkoutRowStyle}>
                        {errorMsg}
                        {waiting}
                    </div>
                </div>
            </div>
        )
    }
}

